import React from 'react';
import { BrowserRouter, useParams } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@/contexts/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import State from './pages/State';
import FAQ from './pages/FAQ';
import Search from './pages/Search';
import Contact from './pages/Contact';
import SupabaseStatus from './components/SupabaseStatus';
import { BlogProvider } from '@/lib/blog/context';
import { BlogList } from '@/components/blog/BlogList';
import { BlogPost } from '@/components/blog/BlogPost';
import About from './pages/About';

const SEOBOT_API_KEY = import.meta.env.VITE_SEOBOT_API_KEY;

if (!SEOBOT_API_KEY) {
  throw new Error('VITE_SEOBOT_API_KEY environment variable is required');
}

// Wrapper component to get slug from URL params
function BlogPostWrapper() {
  const { slug } = useParams<{ slug: string }>();
  return <BlogPost slug={slug || ''} />;
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <BlogProvider apiKey={SEOBOT_API_KEY}>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/reiki/:state" element={<State />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<BlogPostWrapper />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/search" element={<Search />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
              </Routes>
            </Layout>
          </BlogProvider>
          <SupabaseStatus />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;